const baseConstants = {
  COOKIES: {
    KEY: {
      USER_TOKEN: "user-token",
      USER_ID: "user-id",
      USER_NAME: "user-name",
      USER_ROLE: "user-role",
      USER_IS_RESET: "user-is-reset",
      PROJECT_ID: "project-id",
      PROJECT_NAME: "project",
    },
    CONFIG: {
      EXPIRES_1M: { expires: "1M" },
      EXPIRES_1Y: { expires: "1Y" },
    },
    EXPIRES: "expires",
    SAMESITE: "samesite",
    SECURE: "secure",
  },
  ROUTES: {
    DASHBOARD: "/Dashboard",
    CELL: "/Cell",
    SLIDE: "/Slide",
    REPORT: "/Report",
    LOGIN: "/Login",
    USER_MANAGEMENT: "/admin/users",
    PASSWORD_RESET: "/password-reset",
    LPC_DASHBOARD: "/projects/:id/lpc-dashboard",
    RBC_DASHBOARD: "/projects/:id/rbc-dashboard",
    AUDIT_TRAIL: "/admin/audit-trail",
  },
  DATETIME_FORMAT: "YYYY-MM-DD HH:mm",
  DATE_FORMAT: "YYYY-MM-DD",
  DEFAULT_CELL_IMG_SIZE: 256,
  UNCLASSIFIED_CELL: "Unclassified",
  BBOX_ACTIONS: { CLEAR_BBOX: "Clear Bbox" },
  CELL_TAGS: { SELECTED: "Selected", EXCLUDED: "Excluded", UNCLASSIFIED: "Wrong" },
  TASK_STATES_TRANSFORM: {
    Screening: "Relabeling",
    Relabeling: "Final-Review",
    "Final-Review": "Complete",
  },
  TASK_STATES: {
    IN_PROGRESS: "In Progress",
    SCREEN: "Screening",
    RELABELING: "Relabeling",
    FINAL_REVIEW: "Final-Review",
    DONE: "Complete",
  },
  TASK_STATES_ORDER: {
    Screening: 1,
    Relabeling: 2,
    "Final-Review": 3,
  },
  CELL_DEFAULT_SIZE: 1,
  STATES_COUNT: 3,
  LOCALE: { EN: "en" },
  ASSIGNEE_OPTIONS: ["all", "", "siti_thuraiya", "yi_xiong", "eric", "eugene_fan"],
  PROJECT: {
    BONE_MARROW_NTU: "bone-marrow-ntu",
    XAI_NTU: "xai-ntu",
    LPC_RBC_ASUS: "lpc-rbc-asus",
    MALARIA_NUS_IMPERIAL: "malaria-nus-imperial",
    CIASI_RBC: "ciasi-rbc",
    TESTING: "testing",
  },
  PROJECT_DASHBOARD: { "ciasi-rbc": "rbc", "lpc-rbc-asus": "lpc" },
} as const;

type ProjectValue = (typeof baseConstants.PROJECT)[keyof typeof baseConstants.PROJECT];

const projectKeyNameMapping: Record<ProjectValue, string> = {
  [baseConstants.PROJECT.CIASI_RBC]: "CIASI RBC Labelling",
  [baseConstants.PROJECT.BONE_MARROW_NTU]: "Bone Marrow (NTU)",
  [baseConstants.PROJECT.XAI_NTU]: "xAI (NTU)",
  [baseConstants.PROJECT.LPC_RBC_ASUS]: "LPC, RBC (ASUS)",
  [baseConstants.PROJECT.MALARIA_NUS_IMPERIAL]: "Malaria (NUS-Imperial)",
  [baseConstants.PROJECT.TESTING]: "Testing",
};

const projectNameKeyMapping = Object.entries(projectKeyNameMapping).reduce<
  Record<string, ProjectValue>
>((mapping, [key, value]) => {
  mapping[value] = key as ProjectValue;
  return mapping;
}, {});

const AppConstants = {
  ...baseConstants,
  PROJECT_KEY_NAME_MAPPING: projectKeyNameMapping,
  PROJECT_NAME_KEY_MAPPING: projectNameKeyMapping,
  DEFAULT_LOCALE: baseConstants.LOCALE.EN,
  FALLBACK_LOCALE: baseConstants.LOCALE.EN,
} as const;

export default AppConstants;
